import { withTranslation } from 'react-i18next';

import FormVerificationPhoneEmail from '../../components/Forms/FormVerificationPhoneEmail/FormVerificationPhoneEmail';

export default withTranslation()(FormVerificationPhoneEmail);
